module.exports = {
      id: "e1909a6a43b42baa4d2cb49077b87b12sewerage-treatment-plant.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.svg#e1909a6a43b42baa4d2cb49077b87b12sewerage-treatment-plant.svg",
      toString: function () {
        return this.url;
      }
    }